import { render, staticRenderFns } from "./IconExclamationCircleOutline.vue?vue&type=template&id=670cb8a2"
import script from "./IconExclamationCircleOutline.vue?vue&type=script&lang=js"
export * from "./IconExclamationCircleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports